import React from 'react';
import { Link } from 'react-router';

const Logo = React.createClass({
    propTypes: {
        src: React.PropTypes.string.isRequired,
        alt: React.PropTypes.string
    },
    render: function() {
        return (
            <div className="logo">
                <Link to="/">
                    <img src={this.props.src} alt={this.props.alt} />
                </Link>
            </div>
        );
    }
});

export default Logo;



// WEBPACK FOOTER //
// ./src/js/components/Logo.js